<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8aPX4/images/cover.jpg?1708005118543" alt="This image is the cover for the book Gratitude Prayers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gratitude Prayers
      </h1>
      <p class="bookDescription body article font2">
        <p>"The selections in this book will encourage you to pay attention to things that make you laugh, the places that nourish you, the loved ones who inspire and guide you, and caring strangers who bring blessings to your days."—June Cotner<br/><br/><i>Gratitude Prayers </i>is an uplifting collection of inspiring prayers, reflective poems, and motivating quotes that will open you to experience more joy and wonder in life. In this gracious anthology, June Cotner offers more than 100 motivational selections that remind you to embrace each and every day with abundance and thankfulness. <i>Gratitude Prayers</i> includes the voices of classic visionaries such as Rumi, Anne Frank, Walt Whitman and Helen Keller, whose words mingle eloquently alongside contemporary writers such as Michael S. Glaser and Barbara Crooker. The writers in this exuberant book share how to seek out tiny moments of joy, which will point the way toward finding the good in every situation. Divided into ten chapters, <i>Gratitude Prayers</i> offers a transformational perspective on finding happiness through gratefulness. Chapters include: Simple Pleasures, Everyday Life, The Natural World, Friends and Family, Joy and Wonder, Faith and Courage, Prayers and Blessings, as well as Reflections, and Inspirations. In addition, the book closes with a chapter dedicated to what June calls, “Gratitude Boosters,” short, easily read passages that offer the reader an instantaneous paradigm shift.  Let gratitude inspire your attitude with <i>Gratitude Prayers</i>.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        June Cotner
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6468535c